import ATMCodesManagementComponent from './atm_codes_management.component';

let ATMCodesManagementModule = angular.module('atmCodesManagement', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('atm-codes-management');

        $stateProvider
            .state('atmCodesManagement', {
                url: '/atm-codes-management',
                component: 'atmCodesManagement',
                data: {
                    requireLogin: true,
                    requireACL: 'atm_codes_management.all'
                },
                parent: 'app'
            });
    })

    .component('atmCodesManagement', ATMCodesManagementComponent)

    .name;

export default ATMCodesManagementModule;  


// WEBPACK FOOTER //
// ./client/app/components/atm_codes_management/index.js